<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="green" title="Campanhas">
          <v-btn color="primary" text @click="dialogCriar = true">Criar</v-btn>
          <v-data-table :headers="headers" :items="items">
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.nome }}</td>
              <td v-if="item.url" style="width: 100px; height: 50px; object-fit: contain;"><img :src="item.url" style="width: 100px; height: 50px; object-fit: contain;"></td>
              <td v-else style="width: 100px; height: 50px; object-fit: contain;">Imagem</td>
              <td>{{ item.porcentagem }}</td>
              <td>{{ (item.begin).substring(0,10) }}</td>
              <td>{{ (item.end).substring(0,10) }}</td>

              <v-btn color="#000" @click="showProduto(item)">Ver</v-btn>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-snackbar
        color="#000"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="#fff" class="mr-3">mdi-bell-plus</v-icon>
        <div>Campanha atualizado com sucesso!</div>
        <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
      </v-snackbar>

      <v-snackbar
        color="#BA0000"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbarerror"
        dark
      >
        <v-icon color="#fff" class="mr-3">mdi-bell-plus</v-icon>
        <div>
          Verifique os dados e tente novamente
          <br />Verifique a conexão com a internet!
        </div>
        <v-icon size="16" @click="snackbarerror = false">mdi-close-circle</v-icon>
      </v-snackbar>
    </v-layout>

    <v-dialog v-model="dialog" width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Informações sobre a Campanha</v-card-title>
        <v-card-text v-if="selecionado">
          Nome:
          <v-text-field v-model="selecionado.nome"></v-text-field>
        </v-card-text>

        <v-card-text v-if="selecionado">
          Porcentagem:
          <v-text-field v-model="selecionado.porcentagem"></v-text-field>
        </v-card-text>
        <v-card-text v-if="selecionado">
          Início:
          <v-text-field v-model="selecionado.begin"></v-text-field>
        </v-card-text>
        <v-card-text v-if="selecionado">
          Fim:
          <v-text-field v-model="selecionado.end"></v-text-field>
        </v-card-text>
        <v-date-picker v-if="selecionado" v-model="selecionado.end"></v-date-picker>
        <v-card-text v-if="selecionado && selecionado.ativa">
          Ativo:
          <p v-if="selecionado.ativa === true">Ativo</p>
          <p v-else>Desativado</p>
        </v-card-text>

        <input class="ml-3" type="file" id="file" ref="file" v-on:change="handleFileUpload()" />

        <v-card-text v-if="selecionado">
          <b>Produtos:</b>
        </v-card-text>

        <v-text-field v-model="codigoDeBarras" class="ml-3 mr-5" placeholder="Adicionar Produto"></v-text-field>
        <v-btn color="primary" class="ml-3" @click="adicionarProduto()">Adicionar</v-btn>
        <div v-if="selecionado">
          <v-data-table
            :headers="headers_prod"
            :items="selecionado.produtos"
            :items-per-page="5"
            class="elevation-1"
          >
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.nome }}</td>
              <td>{{item.codigoDeBarras}}</td>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="cancelarCampanha()">Cancelar Campanha</v-btn>
          <v-btn color="primary" text @click="atualizar()">Atualizar</v-btn>
          <v-btn color="primary" text @click="fecharDialog()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCriar" width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Criar Campanha</v-card-title>
        <v-card-text>
          Nome:
          <v-text-field v-model="criar.nome"></v-text-field>
        </v-card-text>
        <v-card-text>
          Descrição:
          <v-text-field v-model="criar.descricao"></v-text-field>
        </v-card-text>

        <v-card-text>
          Porcentagem:
          <v-text-field v-model="criar.porcentagem" type="number"></v-text-field>
        </v-card-text>
        <v-row justify="center">
          <v-card-text>Início:</v-card-text>

          <v-date-picker v-model="criar.begin" class="ml-3" dark></v-date-picker>
        </v-row>
        <v-row justify="center">
          <v-card-text>Fim:</v-card-text>
          <v-date-picker v-model="criar.end" class="ml-3" dark></v-date-picker>
        </v-row>
        <br />

        <input class="ml-3 mt-4" type="file" id="file" ref="file" v-on:change="handleFileUpload()" />

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="criarCampanha()">Criar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    dialogeditar: false,
    dialogCriar: false,
    codigoDeBarras: "",
    headers_prod: [
      {
        text: "Nome",
        sortable: false,
        value: "nome"
      },
      { text: "Código de Barras", sortable: false, value: "codigoDeBarras" }
      // { text: "Actions", value: "actions", sortable: false }
    ],
    file: "",
    headers: [
      {
        sortable: false,
        text: "Nome",
        value: "nome"
      },
      {
        sortable: false,
        text: "Banner",
        value: "url"
      },
      {
        sortable: false,
        text: `Porcentagem`,
        align: "center",
        value: "porcentem"
      },
      {
        sortable: false,
        text: "Início",
        value: "begin"
      },
      {
        sortable: false,
        text: "Fim",
        value: "end"
      }
    ],
    snackbar: false,
    codigoDeBarras: null,
    snackbarerror: false,
    categorias: [],
    criar: {
      nome: "",
      descricao: "",
      porcentagem: 0,
      ativa: true,
      begin: new Date().toISOString().substring(0, 10),
      end: new Date().toISOString().substring(0, 10)
    },
    select: null,
    selecionado: null,
    items: [],
    bottom: false,
    top: false,
    left: false,
    right: false
  }),
  beforeMount() {
    this.getCampanhas();
  },
  methods: {
    getCampanhas() {
      this.$http
        .get("/campanhas")
        .then(res => {
          let campanhas = res.data;

          for (let e of campanhas) {
            if (e.image && e.image.key)
              e.url = `http://api-store.emporiodasmarcas.com.br/files/campanhas/${e.image.key}`;
              
              //e.url = `https://api-store.emporiodasmarcas.com.br/files/campanhas/${e.image.key}`;
          }

          // console.log(campanhas);

          this.items = campanhas;
        })
        .catch(err => {if(err.error) alert(err.error)});
    },
    atualizar() {
      if (this.selecionado) {
        let dados = new FormData();
        dados.append("nome", this.selecionado.nome);
        dados.append("descricao", this.selecionado.descricao);
        dados.append("porcentagem", this.selecionado.porcentagem);
        dados.append("begin", this.selecionado.begin);
        dados.append("end", this.selecionado.end);

        if (this.file) dados.append("file", this.file);

        this.$http
          .put(`/campanhas/${this.selecionado._id}`, dados)
          .then(res => {
            this.snackbar = true;
          })
          .catch(err => {
            // console.log(err.error);

            this.snackbarerror = true;
          });
      }
    },
    cancelarCampanha() {
      this.$http
        .delete(`/campanhas/${this.selecionado._id}`)
        .then(() => {
          this.snackbar = true;
          this.dialog = false;
          this.selecionado = null;
        })
        .catch(err => {});
    },
    showProduto(item) {
      this.selecionado = null;
      this.$http
        .get(`/campanha/${item._id}`)
        .then(res => {
          // console.log(res);

          this.selecionado = res.data;
          this.dialog = true;
        })
        .catch(err => {if(err.error) alert(err.error)});
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    adicionarProduto() {
      if (this.codigoDeBarras) {
        this.$http
          .put(
            `/campanhas/${this.selecionado._id}/produto/${this.codigoDeBarras}`
          )
          .then(res => {
            this.selecionado.produto = this.selecionado.produtos.push(res.data);
          })
          .catch(err => {
            if(err.error) alert(err.error)
            
            // console.log(err);
          });
      }
    },
    fecharDialog() {
      this.dialog = false;
      this.selecionado = null;
      this.file = "";
    },
    criarCampanha() {
      let dados_user = JSON.parse(localStorage.getItem("user"));

      let dados = new FormData();
      dados.append("nome", this.criar.nome);
      dados.append("descricao", this.criar.descricao);
      dados.append("porcentagem", this.criar.porcentagem);
      dados.append("begin", this.criar.begin);
      dados.append("end", this.criar.end);
      dados.append("createdBy", dados_user._id);

      if (this.file) dados.append("file", this.file);

      this.$http
        .post(`/campanhas`, dados)
        .then(() => {
          this.snackbar = true;
          this.dialogCriar = false;
          this.file = "";
          this.criar.nome = "";
          this.criar.descricao = "";
          this.criar.porcentagem = 0;
          this.criar.ativa = true;
          this.criar.begin = "";
          this.criar.end = "";
          this.$forceUpdate();
        })
        .catch(() => {
          this.snackbarerror = true;
        });
    }
  }
};
</script>
